
import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

interface NotifyByIconProps {
    notifyBy: "phone" | "mail" | "none"
};

export const NotifyByIcon: React.FC<NotifyByIconProps> = ({ notifyBy }) => {
    const t = useTranslation().t;

    const texts = {
        notificationsByPhone: t("Ilmoitukset lähetetään tekstiviestillä"),
        notificationsByEmail: t("Ilmoitukset lähetetään sähköpostilla"),
        unableToSendNotifications: t("Käyttäjälle ei voida lähettää ilmoituksia"),
    };


    return (
        <span className="item-icon">
            {notifyBy === "phone" ? (
                <span className="item-icon" title={texts.notificationsByPhone}>
                    <Icon name="phone" />{" "}
                </span>
            ) : notifyBy === "mail" ? (
                <span className="item-icon" title={texts.notificationsByEmail}>
                    <Icon name="mail" />{" "}
                </span>
            ) : notifyBy === "none" ? (
                <span className="item-icon" title={texts.unableToSendNotifications}>
                    <Icon name="bell slash" />{" "}
                </span>
            ) : null}
        </span>
    )
}